import { render, staticRenderFns } from "./GeneralStatistics.vue?vue&type=template&id=a5cf0290&"
import script from "./GeneralStatistics.vue?vue&type=script&lang=js&"
export * from "./GeneralStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports